<template>
  <el-table-column
    prop="from"
    label="Honnan"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.type === 'in'">{{ scope.row.from && scope.row.from.company ? scope.row.from.company.name : scope.row.from.name }}</span>
      <span v-else>{{ scope.row.from && scope.row.from.name }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'from',
  };
</script>
